export default {
  styleOverrides: {
    root: {
      '&.MuiOutlinedInput-root': {
        backgroundColor: 'var(--color-bg-paper)',
        borderRadius: '12px',

        '& fieldset': {
          borderColor: 'var(--color-border)',
        },

        '&:hover fieldset': {
          borderColor: 'var(--color-primary)',
        },

        '&.Mui-focused fieldset': {
          borderColor: 'var(--color-primary)',
          borderWidth: 2,
        },

        '&.Mui-disabled': {
          backgroundColor: 'var(--color-action-disabled-bg)',
        },
      },
    },

    select: {
      color: 'var(--color-text-primary)',
      padding: '12px',

      '&:focus': {
        backgroundColor: 'transparent',
      },

      '&.Mui-disabled': {
        color: 'var(--color-text-disabled)',
      },
    },

    icon: {
      color: 'var(--color-text-secondary)',

      '&.Mui-disabled': {
        color: 'var(--color-text-disabled)',
      },
    },
  },
};
